import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getParam, useAuthProvider, getCdnUrl } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import { ReactSortable } from "react-sortablejs";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import DataTable from  "@cloudpremise/portal_core/src/themes/mui/examples/Tables/DataTable";

import Config from "../../../../Config";

// @mui material components
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import IconButton from '@mui/material/IconButton';
import Link from "@mui/material/Link";

import OGControl from "../components/OGControl";
import mapboxgl, { Map as MapboxMap } from "mapbox-gl";
mapboxgl.accessToken = Config.getMapboxAccessToken();

import "mapbox-gl/dist/mapbox-gl.css";
import "../styles/home.scss";

const Home = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const ogControlRef = React.useRef<OGControl>();
    const mapRef = React.useRef<MapboxMap>();
    const mapContainer = React.useRef(null);
    const cdnUrl = getCdnUrl();
    const defaultState = {
        mapReady: false,
        doctors: [
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-121.4141, 38.5960],
                },
                properties: {
                    name: "Dr. Sarah Mitchell",
                    address: "1280 Sunrise Blvd, Suite 201, Sacramento, CA",
                    zipcode: "95825",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-87.6430, 41.9026],
                },
                properties: {
                    name: "Dr. James O’Connor",
                    address: "52 W Elm Street, Chicago, IL",
                    zipcode: "60610",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-95.4373, 29.7310],
                },
                properties: {
                    name: "Dr. Priya Nair",
                    address: "2121 Greenway Plaza, Houston, TX",
                    zipcode: "77046",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-81.4257, 28.4296],
                },
                properties: {
                    name: "Dr. Miguel Herrera",
                    address: "9900 Southpoint Drive, Orlando, FL",
                    zipcode: "32819",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-117.1595, 32.7440],
                },
                properties: {
                    name: "Dr. Elizabeth Chen",
                    address: "77 Grove Avenue, San Diego, CA",
                    zipcode: "92103",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-118.4656, 34.1526],
                },
                properties: {
                    name: "Dr. Laura Kim",
                    address: "5500 Ventura Blvd, Los Angeles, CA",
                    zipcode: "91403",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-106.6597, 35.0914],
                },
                properties: {
                    name: "Dr. Anthony Martinez",
                    address: "1234 Lomas Blvd NW, Albuquerque, NM",
                    zipcode: "87102",
                    type: "doctor"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-115.2086, 36.1186],
                },
                properties: {
                    name: "Dr. Rebecca Stone",
                    address: "4001 S Decatur Blvd, Las Vegas, NV",
                    zipcode: "89103",
                    type: "doctor"
                },
            },
        ],
        patients: [
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-104.9751, 39.7195],
                },
                properties: {
                    name: "Anna Thompson",
                    address: "145 Riverbend Lane, Denver, CO",
                    zipcode: "80203",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-86.7256, 36.0583],
                },
                properties: {
                    name: "Michael Carter",
                    address: "621 Pine Hollow Road, Nashville, TN",
                    zipcode: "37211",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-78.6200, 35.8466],
                },
                properties: {
                    name: "Lena Gomez",
                    address: "33 Orchard Park Drive, Raleigh, NC",
                    zipcode: "27609",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-122.3032, 47.6893],
                },
                properties: {
                    name: "Jason Lee",
                    address: "8844 Sunset Trail, Seattle, WA",
                    zipcode: "98115",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-112.0243, 33.5125],
                },
                properties: {
                    name: "Natalie Brooks",
                    address: "505 Windmill Way, Phoenix, AZ",
                    zipcode: "85016",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-112.2574, 33.5696],
                },
                properties: {
                    name: "Carlos Rivera",
                    address: "9055 W Olive Ave, Peoria, AZ",
                    zipcode: "85345",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-122.4084, 37.7781],
                },
                properties: {
                    name: "Emily Zhang",
                    address: "980 Harrison St, San Francisco, CA",
                    zipcode: "94107",
                    type: "patient"
                },
            },
            {
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [-106.5964, 35.0797],
                },
                properties: {
                    name: "Thomas Greene",
                    address: "4400 Central Ave SE, Albuquerque, NM",
                    zipcode: "87108",
                    type: "patient"
                },
            },
        ],
        markerType: "",
        currentTab: "doctors",
        tabs: [
            {
                name: "doctors",
                label: "Doctors"
            },
            {
                name: "patients",
                label: "Patients"
            },
        ],
        doctorName: "",
        doctorAddress: "",
        doctorZipcode: "",
        patientName: "",
        patientAddress: "",
        patientZipcode: "",
        searchDoctor: "",
        searchPatient: "",
        searchResults: []
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();
    
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing"+window.location.search, { replace: true });
        }
        if(authorized && (authType !== "link" && authType !== "microsoft" && authType !== "google" && authType !== "github" && authType !== "facebook")){
            return navigate("/auth-not-supported", { replace: true });
        }

        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [-104.9751, 39.7195],
            zoom: 4,
            projection: 'globe'
        });
        map.addControl(new mapboxgl.NavigationControl({
            visualizePitch: true
        }), 'bottom-right');
        map.addControl(new mapboxgl.FullscreenControl(), 'bottom-right');
        const ogControl = new OGControl({
            doctors: state.doctors,
            patients: state.patients,
            onMoveEnd: (results) => {
                setState({
                    searchResults: results
                })
            }
        });
        ogControlRef.current = ogControl;
        map.addControl(ogControl, 'bottom-left');
        map.addControl(new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true,
            showUserHeading: true
        }), 'bottom-right');

        map.on("load", () => {
            map.loadImage(cdnUrl+'/assets/img/marker.png', (error, image) => {
                if (error) throw error;
                if (!map.hasImage('marker-icon')) {
                    map.addImage('marker-icon', image);
                }
            });

            map.loadImage(cdnUrl+'/assets/img/marker-black.png', (error, image) => {
                if (error) throw error;
                if (!map.hasImage('markerb-icon')) {
                    map.addImage('markerb-icon', image);
                }
            });            
        });
        
        mapRef.current = map;
        return () => map.remove();
    }, []);
    
    function onTabChange(event, tab){
        setState({
            currentTab: tab
        });
    }

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }

    function renderTab(tab){
        return (
            <Tab
                label={tab.label}
                value={tab.name}
                key={tab.name}
            />
        )
    }
    function renderTabs(){
        return (
            <Tabs
                orientation={state.tabsOrientation}
                value={state.currentTab}
                onChange={onTabChange}
            >
                {
                    state.tabs.map((tab) => {
                        return renderTab(tab)
                    })
                }
            </Tabs>
        )
    }
    function onPinDrop(e){
        const markerType = state.currentTab === "doctors" ? "doctor" : "patient";
        let name = state.patientName;
        let address = state.patientAddress;
        let zipcode = state.patientZipcode;
        if(markerType === "doctor"){
            name = state.doctorName;
            address = state.doctorAddress;
            zipcode = state.doctorZipcode;
        }
        ogControlRef.current.onPinDrop(e, markerType, name, address, zipcode);
        if(markerType === "doctor"){
            setState({
                doctorName: "",
                doctorAddress: "",
                doctorZipcode: ""
            });
        }else{
            setState({
                patientName: "",
                patientAddress: "",
                patientZipcode: ""
            });
        }
    }
    function onSearch(type, query){
        const results = ogControlRef.current.onSearch(type, query);
        setState({
            searchResults: results
        });
    }
    function handleRowAction(event, item){
        event.preventDefault();
        ogControlRef.current.onResultClick(item.feature);
	}
    function getSearchResults(){
        const tableData = {
            columns: [
                {Header: "Type", accessor: "type", width: "20%" },
                {
                    Header: "Name",
                    accessor: "name",
                    width: "30%",
                    Cell: (instance) => {
                        return (
                            <Link href="/" onClick={(event) => handleRowAction(event, instance.row.original)}>
                                {instance.value}
                            </Link>
                        )
                    },
                },
                { Header: "Address", accessor: "address", width: "50%" },
                // { Header: "Zipcode", accessor: "zipcode", width: "20%" },
            ],
            rows: []
        };
        state.searchResults.map((feature) => {
            tableData.rows.push({
                ...feature.properties,
                feature: feature,
            });
            return null;
        });

        return tableData;
    }
    function onClearSearch(){
        setState({
            searchDoctor: "",
            searchPatient: "",
            searchResults: []
        });
    }
    if(!authorized){
        return null;
    }
    const tableDataItems = getSearchResults();
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <MDBox mb={2}>
                    <MDTypography variant="h3">Olympus-Grid Map</MDTypography>
                </MDBox>
                <MDBox className="mapboxgl-ctrl og-ctrl">
                    <MDBox>
                        {renderTabs()}
                    </MDBox>
                    <MDBox mt={2} className={"tab-"+state.currentTab}>
                        {
                            state.currentTab === "doctors" ?
                                <MDBox mb={2}>
                                    <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                                        Drag a Pin:
                                    </MDTypography>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} md={4} lg={2}>
                                            <MDInput
                                                name="doctorName"
                                                type="text"
                                                label="Doctor Name"
                                                value={state.doctorName}
                                                onChange={(e) => handleChange(e, "doctorName")}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={1} style={{width: "auto", flexBasis: "auto"}}>
                                            <ReactSortable
                                                list={[{ id: "doctor", label: "Doctor" }]}
                                                setList={() => {}}
                                                group={{ name: "pins", pull: "clone", put: false }}
                                                sort={false}
                                            >
                                                <div data-type="doctor" style={{ cursor: "move", margin: "5px", padding: "5px", display: "inline-block", textAlign: "center" }}>
                                                    <img src={cdnUrl+'/assets/img/marker.png'} style={{width: "24px"}} />
                                                </div>
                                            </ReactSortable>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2}>
                                            <MDInput
                                                name="searchDoctor"
                                                type="text"
                                                label="Search"
                                                placeholder="Search by name, address or zip code."
                                                value={state.searchDoctor}
                                                onChange={(e) => handleChange(e, "searchDoctor")}
                                                fullWidth
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="Search"
                                                                edge="end"
                                                                onClick={() => onSearch('doctor', state.searchDoctor)}
                                                            >
                                                                <SearchOutlinedIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2} sx={{width: "auto", flexBasis: "auto"}}>
                                            <MDButton variant="outlined" color="light" onClick={() => onClearSearch()}>
                                                Clear Search
                                            </MDButton>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            :
                                <MDBox mb={2}>
                                    <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                                        Drag a Pin:
                                    </MDTypography>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} md={4} lg={2}>
                                            <MDInput
                                                name="patientName"
                                                type="text"
                                                label="Patient Name"
                                                value={state.patientName}
                                                onChange={(e) => handleChange(e, "patientName")}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={1} style={{width: "auto", flexBasis: "auto"}}>
                                            <ReactSortable
                                                list={[{ id: "patient", label: "Patient" }]}
                                                setList={() => {}}
                                                group={{ name: "pins", pull: "clone", put: false }}
                                                sort={false}
                                            >
                                                <div data-type="patient" style={{ cursor: "move", margin: "5px", padding: "5px", display: "inline-block", textAlign: "center" }}>
                                                    <img src={cdnUrl+'/assets/img/marker-black.png'} style={{width: "24px"}} />
                                                </div>
                                            </ReactSortable>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2}>
                                            <MDInput
                                                name="searchPatient"
                                                type="text"
                                                label="Search"
                                                placeholder="Search by name, address or zip code."
                                                value={state.searchPatient}
                                                onChange={(e) => handleChange(e, "searchPatient")}
                                                fullWidth
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="Search"
                                                                edge="end"
                                                                onClick={() => onSearch('patient', state.searchPatient)}
                                                            >
                                                                <SearchOutlinedIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={2}>
                                            <MDButton variant="outlined" color="light" onClick={() => onClearSearch()}>
                                                Clear Search
                                            </MDButton>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                        }
                    </MDBox>
                </MDBox>
                <MDBox mb={2} sx={{textTransform: "capitalize"}}>
                    <DataTable
                        table={tableDataItems}
                        canSearch={false}
                        rowsCount={tableDataItems.rows.length}
                        entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                    />
                </MDBox>
                <div
                    className="mapboxgl-map"
                    ref={mapContainer}
                    style={{height: '600px', width: '100%'}}
                    onDragOver={(e) => {
                        e.preventDefault(); // 👈 allows dropping
                        e.dataTransfer.dropEffect = "move";
                    }}
                    onDrop={(e) => {
                        e.preventDefault();
                        onPinDrop(e);
                    }}
                ></div>
            </MDBox>
        </DashboardLayout>
    )
}

export default Home;